import { type ShiftStateData } from "@src/appV2/Shifts/Shift/ShiftState/types";
import type { WorkerShift } from "@src/appV2/Shifts/Shift/types";

import { InstantPayFooter } from "./InstantPayFooter";
import { NonInstantPayFooter } from "./NonInstantPayFooter";

export interface ShiftDetailsFooterProps {
  shift: WorkerShift;
  shiftState: ShiftStateData;
  currentDate: Date;
  onClockIn: () => void;
  onUpdateETA: () => void;
  onCancelShift: () => void;
  onTransferShift: () => void;
  onSentHome: () => void;
  onUploadTimesheet: () => void;
  isUploadingTimesheet: boolean;
  isMissedPunchRequestEnabled: boolean;
  isBadgeVerificationEnabled: boolean;
}

/**
 * Unified footer component that chooses between InstantPayFooter and NonInstantPayFooter
 * based on shift type. This maintains the existing API while leveraging the separated components.
 */
function ShiftDetailsFooter(props: ShiftDetailsFooterProps) {
  const {
    shift,
    shiftState,
    currentDate,
    onClockIn,
    onUpdateETA,
    onCancelShift,
    onTransferShift,
    onSentHome,
    onUploadTimesheet,
    isUploadingTimesheet,
    isMissedPunchRequestEnabled,
    isBadgeVerificationEnabled,
  } = props;

  if (shift.isInstantPay) {
    return (
      <InstantPayFooter
        shift={shift}
        shiftState={shiftState}
        currentDate={currentDate}
        isBadgeVerificationEnabled={isBadgeVerificationEnabled}
        onClockIn={onClockIn}
        onUpdateETA={onUpdateETA}
        onCancelShift={onCancelShift}
        onTransferShift={onTransferShift}
        onSentHome={onSentHome}
      />
    );
  }

  return (
    <NonInstantPayFooter
      shift={shift}
      shiftState={shiftState}
      currentDate={currentDate}
      isUploadingTimesheet={isUploadingTimesheet}
      isMissedPunchRequestEnabled={isMissedPunchRequestEnabled}
      onUpdateETA={onUpdateETA}
      onCancelShift={onCancelShift}
      onSentHome={onSentHome}
      onUploadTimesheet={onUploadTimesheet}
    />
  );
}

export { ShiftDetailsFooter };
